<template>
  <Form ref="changeEmailForm">
    <base-input
      name="email"
      :text="$t('Add a new email address')"
      type="email"
      :required="true"
      :model-value="email"
      :validation-rules="validationRules"
      @update:model-value="$emit('change', $event)"
    >
      <template #label>
        {{ $t('Add a new email address') }}
      </template>
      <template #errorMessage="{ failedRules }">
        <translate v-if="failedRules.includes('required')" tag="div">
          Please enter your email address
        </translate>
        <translate v-else-if="failedRules.includes('invalid-email')" tag="div">
          Please enter a valid email address
        </translate>
        <translate v-else tag="div">
          {{ failedRules }}
        </translate>
      </template>
    </base-input>

    <div class="action-buttons">
      <a class="button minimal cancel" @click.prevent="$emit('cancel')">{{
        $t('Cancel')
      }}</a>
      <base-submit-button :submitting="isSubmitting" class="primary asblock">
        {{ $t('Save') }}
        <template #submittingText>
          <translate>Saving...</translate>
        </template>
      </base-submit-button>
    </div>
  </Form>
</template>

<script lang="ts">
import { Form } from 'vee-validate'
import {
  Component,
  Prop,
  Vue,
  Watch,
  toNative,
} from '~/utility/pu-class-decorator'
import * as z from 'zod'

type Errors = Record<string, string[]>

@Component({
  components: { Form },
  emits: ['change', 'cancel'],
})
class ChangeEmailForm extends Vue {
  @Prop()
  email: string

  @Prop({ default: () => {} })
  errors: Errors

  @Prop()
  isSubmitting: boolean

  @Watch('errors')
  onErrorsChanged(errors: Errors) {
    this.$refs.changeEmailForm.setErrors(errors)
  }

  validationRules = z
    .string({ required_error: 'required' })
    .min(1, { message: 'required' })
    .email({ message: 'invalid-email' })

  submitForm() {
    this.$emit('submit')
  }
}

export default toNative(ChangeEmailForm)
</script>

<style scoped>
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 1em 0 0;
  padding-bottom: 1em;
  gap: 2em;
}

.cancel {
  margin-top: 0.25em;
}
</style>
